import validator from "validator";

export function createSchoolFormValidator(values) {
  const errors: any = {};

  if (!values.name) errors.name = "Name is required";

  if (!values.type) errors.type = "Type is required";

  if (!values.countryObj) {
    errors.countryObj = "Country is required.";
  }

  if (!values.website) {
    errors.website = "Website is required.";
  } else if (!validator.isURL(values.website.trim())) {
    errors.website = "Website must be a valid url.";
  }

  return errors;
}

export function branchFormValidator(values) {
  const errors: any = {};

  if (!values.country) errors.country = "Country is required";

  if (!values.city) errors.city = "City is required";

  if (!values.address) errors.address = "Address is required";

  if (!values.zip) errors.zip = "Zip is required";

  return errors;
}
